const gql = String.raw;

const proposalQueries = {
  proposal: gql`
    query ($proposalId: BigInt!) {
      proposal(proposalId: $proposalId) {
        id
        title
        primary_proposal_unit
        additional_proposal_category
      }
    }
  `,
  searchProposalsByContactId: gql`
    query searchProposalsByContactId($contact_ids: [BigInt!]!, $title_search: String, $limit: Int) {
      searchProposalsByContactId(contact_ids: $contact_ids, title_search: $title_search, limit: $limit) {
        id
        title
        label
      }
    }
  `,
};

export default proposalQueries;
